import React from 'react';
import { bookingListSummary } from './BookingEventCard';
import { agendaEventsForDay } from '../agendaExperience';

export default function AgendaDayList({ events = [], selectedDate, resources = [], roleContext, timeFormat, onEventClick, onShowTeam }) {
  const rows = agendaEventsForDay(events, selectedDate, resources);
  return <section className="agenda-day-list" aria-label="Reservas del día">
    <p className="agenda-day-list-count">{rows.length} {rows.length === 1 ? 'reserva' : 'reservas'} en esta vista</p>
    {rows.length ? rows.map((event, index) => {
      const item = bookingListSummary(event, roleContext, timeFormat);
      return <button type="button" className="agenda-list-booking" key={event.id || index} onClick={() => onEventClick(event)}>
        <span className="agenda-list-booking-top"><strong>{item.clientName}</strong>{item.priceLabel && <span>{item.priceLabel}</span>}</span>
        <span className="agenda-list-booking-service">{item.serviceName}</span>
        <span className="agenda-list-booking-meta"><span>{item.displayTime}</span><span>{item.status.label}</span></span>
        <span className="agenda-list-booking-meta"><span>{[item.workerName,item.durationLabel].filter(Boolean).join(' · ')}</span>{item.membershipLabel && <span>Membresía</span>}{item.loyaltyLabel && <span>Fidelidad</span>}</span>
      </button>;
    }) : <div className="agenda-day-empty">
      <strong>No hay reservas en esta vista</strong>
      <p>Consulta los espacios disponibles en la agenda del equipo.</p>
      <button type="button" onClick={onShowTeam}>Ver horarios</button>
    </div>}
  </section>;
}
